<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" data-title="B2B 렌탈 문의" :type="'home'"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content" class="type2">
        <section class="mb20">
          <div class="titArea">
            <h3 class="titH3 normal">B2B 렌탈 문의</h3>
          </div>

          <div class="guideMsg mb0">
            <p class="txt">
              웰릭스렌탈은 기업과 제품을 연결하여
              <br />
              만족도 높은 서비스를 제공 합니다.
            </p>
          </div>
        </section>

        <section class="hr">
          <div class="titArea">
            <h3 class="titH4">B2B 렌탈 서비스</h3>
          </div>

          <div class="guideMsg">
            <p class="txtS">
              기업과 사업장 등 대량의 제품렌탈 및 구매가 필요한 곳에
              <br />
              만족 높은 서비스를 제공합니다.
            </p>
          </div>

          <ul class="benefitList row3">
            <li>
              <div class="bnfcon">
                <span class="img">
                  <img src="@/../static/img/mw/content/ico_b2b_1.png" alt="" />
                </span>
                <span class="tit">
                  B2B렌탈
                  <br />
                  전문상담
                </span>
                <span class="desc">기업과 사업장에 필요한 전문 상담을 통하여 합리적인 견적을 서비스해 드립니다.</span>
              </div>
            </li>
            <li>
              <div class="bnfcon">
                <span class="img">
                  <img src="@/../static/img/mw/content/ico_b2b_2.png" alt="" />
                </span>
                <span class="tit">
                  렌탈기간
                  <br />
                  커스텀
                </span>
                <span class="desc">전형적인 렌탈기간 외 필요한 기간만큼 맞춤 렌탈기간 설정 서비스를 제공해 드립니다.</span>
              </div>
            </li>
            <li>
              <div class="bnfcon">
                <span class="img">
                  <img src="@/../static/img/mw/content/ico_b2b_3.png" alt="" />
                </span>
                <span class="tit">
                  설치비/등록비
                  <br />
                  면제
                </span>
                <span class="desc">
                  렌탈 초기 비용인 제품 설치비 및 등록비는 면제해 드립니다.
                  <br />
                  (*일부제품 제외)
                </span>
              </div>
            </li>
            <li>
              <div class="bnfcon">
                <span class="img">
                  <img src="@/../static/img/mw/content/ico_b2b_4.png" alt="" />
                </span>
                <span class="tit">
                  무상 A/S
                  <br />
                  서비스
                </span>
                <span class="desc">
                  사용하시는 렌탈기간내 무상 A/S 서비스를 제공해 드립니다.
                  <br />
                  (*소모품 제외)
                </span>
              </div>
            </li>
          </ul>
        </section>

        <section class="hr">
          <div class="titArea">
            <h3 class="titH4">B2B 렌탈 서비스 전문 담당자</h3>
          </div>

          <div class="guideMsg">
            <p class="txtS">
              B2B 렌탈의 풍부한 경험을 가진 전문담당자가
              <br />
              도와드리겠습니다.
            </p>
          </div>

          <div class="img"><img src="@/../static/img/mw/content/img_b2b_1.png" alt="" /></div>
          <p class="txtS mt20">
            <em>음식물 처리기 문의</em>
            : bjkang@welrixrental.co.kr
            <br />
            <em>그 외 모든 상품 문의</em>
            : jhkim2@welrixrental.co.kr
          </p>
        </section>

        <section class="hr mb20">
          <div class="titArea">
            <h3 class="titH4">B2B 렌탈 서비스 진행 절차</h3>
          </div>

          <div class="guideMsg mb0">
            <p class="txtS">
              기업과 사업장 등 대량의 제품렌탈 및
              <br />
              구매가 필요한 곳에 만족 높은 서비스를 제공합니다.
            </p>
          </div>

          <div class="progress">
            <ol>
              <li class="on">
                <span>
                  고객님의
                  <br />
                  견적요청
                </span>
              </li>
              <li>
                <span>
                  상담 및
                  <br />
                  견적서 제안
                </span>
              </li>
              <li>
                <span>
                  견적서 확인
                  <br />
                  계약 진행
                </span>
              </li>
              <li>
                <span>
                  렌탈 서비스
                  <br />
                  시작
                </span>
              </li>
            </ol>
          </div>
        </section>

        <section class="hr">
          <!-- 약관 (s) -->
          <div class="termsWrap mt5">
            <div class="block accoHead">
              <input type="checkbox" class="ipt" name="terms1" id="terms1_all" @click="showPopup('all')" />
              <label for="terms1_all">전체동의</label>
            </div>

            <p class="txtXS pointC6 mb10">
              고객 편의 제공을 위하여 여러 동의사항에 대한 '전체 동의' 기능을 제공하고 있습니다.
            </p>

            <div class="accoBody">
              <ul class="iptGroup">
                <li>
                  <div class="block">
                    <input type="checkbox" class="ipt" name="termsSub" value="0" id="terms1_3" @click="showPopup('privacy')" />
                    <label for="terms1_3">
                      <span>[필수]</span>
                      개인정보 수집 및 이용 안내
                    </label>
                    <button type="button" class="links arrow" @click="showPopup('privacy')"><span class="blind">상세약관 내용보기</span></button>
                  </div>
                </li>
                <li>
                  <div class="block">
                    <input type="checkbox" class="ipt" name="termsSub" value="1" id="terms1_4" @click="showPopup('notice')" />
                    <label for="terms1_4">
                      <span>[필수]</span>
                      유의사항
                    </label>
                    <button type="button" class="links arrow" @click="showPopup('notice')"><span class="blind">상세약관 내용보기</span></button>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!-- 약관 (e) -->
        </section>

        <ValidationObserver ref="form">
          <section>
            <div class="titArea">
              <h3 class="titH4">B2B 렌탈 서비스 신청</h3>
            </div>
            <p class="pointC1">※B2B 렌탈 견적문의 외엔 응대가 되지 않을 수 있습니다.</p>

            <div class="formArea">
              <span class="label">
                카테고리
                <span class="required"><span class="blind">필수</span></span>
              </span>
              <ValidationProvider name="카테고리" rules="required" v-slot="{ errors }">
                <input type="text" class="ipt" placeholder="예) 에어컨 (10대), 냉장고 (5대) ..." title="카테고리 입력" v-model="fld" />
                <p class="fieldMsg error" id="idMsg" v-if="errors[0]">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
              <span class="label">사용처</span>
              <input
                type="text"
                class="ipt"
                placeholder="예) 사무실, 숙박업, 관공서, 학교, 병원, 군부대, 기타 ..."
                title="사용처 입력"
                v-model="use_plc"
              />

              <span class="label">상세내용</span>
              <textarea class="ipt" title="상세내용 입력" placeholder="구체적인 사항이 있으시면 작성해 주세요." v-model="spec_cntn"></textarea>
            </div>
          </section>

          <section>
            <div class="titArea">
              <h3 class="titH4">신청자 정보</h3>
            </div>

            <div class="formArea">
              <span class="label">
                이름
                <span class="required"><span class="blind">필수</span></span>
              </span>
              <ValidationProvider name="이름" rules="required" v-slot="{ errors }">
                <input type="text" class="ipt" placeholder="렌탈업체㈜" title="이름 입력" v-model="aplt_nm" />
                <p class="fieldMsg error" id="idMsg" v-if="errors[0]">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>

              <span class="label">
                연락처
                <span class="required"><span class="blind">필수</span></span>
              </span>
              <ValidationProvider name="연락처" rules="required" v-slot="{ errors }">
                <input type="text" class="ipt" placeholder="'-' 없이 숫자만 입력" title="연락처 입력" v-model="aplt_tel" />
                <p class="fieldMsg error" id="idMsg" v-if="errors[0]">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>

              <span class="label">이메일</span>
              <input type="text" class="ipt" placeholder="email@email.com" title="이메일 입력" v-model="aplt_emal" />
            </div>
          </section>

          <section>
            <div class="titArea">
              <h3 class="titH4">사업자 정보</h3>
            </div>

            <div class="formArea">
              <span class="label">
                구분
                <span class="required"><span class="blind">필수</span></span>
              </span>
              <ul class="iptGroup iptBtn mini">
                <li>
                  <input type="radio" class="ipt" name="rdosort" id="btn_1" checked="checked" value="CS010003" v-model="div" />
                  <label for="btn_1"><span class="ico">사업자(개인)</span></label>
                </li>
                <li>
                  <input type="radio" class="ipt" name="rdosort" id="btn_2" value="CS010002" v-model="div" />
                  <label for="btn_2"><span class="ico">사업자(법인)</span></label>
                </li>
                <li>
                  <input type="radio" class="ipt" name="rdosort" id="btn_3" value="CS010001" v-model="div" />
                  <label for="btn_3"><span class="ico">사업자아님</span></label>
                </li>
              </ul>
              <div v-if="div !== 'CS010001'">
                <span class="label">
                  상호
                  <span class="required"><span class="blind">필수</span></span>
                </span>
                <ValidationProvider name="상호" rules="required" v-slot="{ errors }">
                  <input type="text" class="ipt" placeholder="상호명" title="상호 입력" v-model="biz_nm" />
                  <p class="fieldMsg error" id="idMsg" v-if="errors[0]">
                    {{ errors[0] }}
                  </p>
                </ValidationProvider>

                <span class="label">
                  사업자등록번호
                  <span class="required"><span class="blind">필수</span></span>
                </span>
                <ValidationProvider name="사업자등록번호" rules="required" v-slot="{ errors }">
                  <input type="text" class="ipt" placeholder="123-45-67890" title="사업자등록번호 입력" maxlength="12" v-model="biz_no" />
                  <p class="fieldMsg error" id="idMsg" v-if="errors[0]">
                    {{ errors[0] }}
                  </p>
                </ValidationProvider>
              </div>
            </div>

            <div class="btnArea sticky">
              <button type="button" class="btn_p" @click="inquery">문의하기</button>
            </div>
          </section>
        </ValidationObserver>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
    <!-- popup (s) -->
    <div class="popWrap nowOpen" v-if="popup">
      <div class="popup">
        <div class="popContain">
          <div class="popCont full">
            <div class="popHead">
              <h1 class="titH1">
                <p v-if="term == 'privacy'">개인정보 수집 및 이용 안내</p>
                <p v-else-if="term == 'notice'">유의사항</p>
                <p v-else>전체약관</p>
              </h1>
            </div>
            <div class="popBody">
              <div class="popInner">
                <!-- 본문 (s) -->
                <section v-show="term == 'privacy' || term == 'all'" class="termsDetail">
                  <div class="titArea">
                    <p class="titH5">개인정보 수집 및 이용에 대한 안내</p>
                    <p class="txt pointC8">
                      웰릭스렌탈(주)는 제휴 및 대리점 가맹문의를 희망하는 기업 및 개인을 대상으로 아래와 같이 개인정보를 수집하고 있습니다.
                    </p>
                  </div>

                  <ul class="pointC8">
                    <li>1. 수집 개인정보 항목: [필수] 회사/업체명, 담당자명, 연락처, 이메일</li>
                    <li>2. 개인정보의 수집 및 이용목적: 제휴 및 대리점 가맹신청에 따른 본인확인 및 원할한 의사소통 경로 확보</li>
                    <li>3. 개인정보의 이용기간: 모든 검토가 완료된 후 1개월 후 해당정보를 즉시 파기합니다.</li>
                    <li>4. 그 밖의 사항은 각 사별 개인정보처리방침을 준수합니다.</li>
                  </ul>
                </section>
                <!-- 본문 (e) -->

                <!-- 본문 (s) -->
                <section v-show="term == 'notice' || term == 'all'" class="termsDetail">
                  <div class="titArea">
                    <p class="titH5">개인정보 수집 및 이용에 대한 안내</p>
                  </div>
                  <p class="txt pointC8">
                    웰릭스렌탈(주)는 보내주신 제휴문의 또는 대리점 가맹문의를 검토한 후 사업 진행이 결정되면 꼭 연락을 드려 함께 진행할 수 있도록
                    하겠습니다.
                    <br />
                    다만, 문의 검토 후 이를 거절할 수 있고 이 경우 문의자에 대한 보상, 회신 등 기타 의무를 부담하지 않는다는 점 양해 부탁드립니다.
                    한편, 제휴문의 또는 대리점 가맹문의 내용 및 관련 자료는 제휴 검토 목적으로만 이용되며, 문의가 받아들여지지 않을 경우 즉시
                    파기됩니다.
                  </p>
                </section>
                <!-- 본문 (e) -->
              </div>
            </div>

            <div class="btnArea sticky">
              <button type="button" class="btn_p" @click="agree(term)">동의</button>
            </div>

            <button type="button" class="btnIco_close" @click="popupClose">
              <span>팝업 닫기</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- popup (e) -->
    <MessagePop v-if="messagePop" @close="close">
      <p v-html="msg"></p>
    </MessagePop>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import JwtService from '@/common/jwt.service';
import MessagePop from '@/components/popup/MessagePop';
import { INPUT_INFO_CHECK, TERM_AGREE_CHECK } from '@/store/message.type';
export default {
  name: 'B2BRentalInquery',
  components: { MessagePop },
  data() {
    return {
      agrAct0: true,
      chkSubNum: '-1',
      chkSubCnt: 0,
      chkAll: false,
      chkSub: [],
      popup: false,
      term: 'notice',

      msg: '',
      messagePop: false,
      success: false,

      aplt_emal: '', // 이메일
      aplt_nm: '', // 이름
      aplt_tel: '', // 연락처
      b2b_no: '',
      biz_nm: '', // 상호
      biz_no: '', // 사업자번호
      cnfm: 0,
      crte_id: '비회원', // 아이디
      div: 'CS010001', // 사업자구분
      fld: '', // 카테고리
      mgr_memo: '',
      spec_cntn: '', // 상세내용
      use_plc: '', // 사용처
    };
  },
  watch: {
    chkSub() {
      console.log(this.chkSub);
      if (this.chkSub.length == 2) {
        this.chkAll = true;
        document.getElementById('terms1_all').checked = 'checked';
      } else {
        this.chkAll = false;
        document.getElementById('terms1_all').checked = '';
      }
    },
  },
  methods: {
    refresh() {
      this.chkAll = false;
      this.chkSub = [];
      document.getElementById('terms1_all').checked = '';
      document.getElementById('terms1_3').checked = '';
      document.getElementById('terms1_4').checked = '';
      this.aplt_emal = ''; // 이메일
      this.aplt_nm = ''; // 이름
      this.aplt_tel = ''; // 연락처
      this.b2b_no = '';
      this.biz_nm = ''; // 상호
      this.biz_no = ''; // 사업자번호
      this.cnfm = 0;
      this.crte_id = '비회원'; // 아이디
      this.div = 'CS010001'; // 사업자구분
      this.fld = ''; // 카테고리
      this.mgr_memo = '';
      this.spec_cntn = ''; // 상세내용
      this.use_plc = ''; // 사용처
      this.$refs.form.reset();
    },
    showPopup(term) {
      if (term == 'all') {
        document.getElementById('terms1_all').checked = '';
        if (this.chkAll) {
          this.chkAll = false;
          this.chkSub = [];
          document.getElementById('terms1_3').checked = '';
          document.getElementById('terms1_4').checked = '';
          return;
        }
      } else if (term == 'privacy') {
        document.getElementById('terms1_3').checked = '';
        if (this.chkSub.indexOf(0) != -1) {
          this.chkSub.splice(this.chkSub.indexOf(0), 1);
          return;
        }
      } else if (term == 'notice') {
        document.getElementById('terms1_4').checked = '';
        if (this.chkSub.indexOf(1) != -1) {
          this.chkSub.splice(this.chkSub.indexOf(1), 1);
          return;
        }
      }
      this.term = term;
      this.popup = true;
    },
    popupClose() {
      this.popup = false;
    },
    agree(term) {
      console.log(term);
      if (term == 'all') {
        this.chkAll = true;
        this.chkSub = [0, 1];
        document.getElementById('terms1_all').checked = 'checked';
        document.getElementById('terms1_3').checked = 'checked';
        document.getElementById('terms1_4').checked = 'checked';
      } else if (term == 'privacy') {
        document.getElementById('terms1_3').checked = 'checked';
        if (this.chkSub.indexOf(0) == -1) this.chkSub.push(0);
      } else if (term == 'notice') {
        document.getElementById('terms1_4').checked = 'checked';
        if (this.chkSub.indexOf(1) == -1) this.chkSub.push(1);
      }

      this.popup = false;
    },
    inquery() {
      if (this.chkSub.length != 2) {
        this.msg = TERM_AGREE_CHECK;
        this.messagePop = true;
        return;
      }

      this.$refs.form.validate().then(async success => {
        if (!success) {
          this.msg = INPUT_INFO_CHECK;
          this.messagePop = true;
        } else {
          if (JwtService.getToken()) {
            this.crte_id = JwtService.getUserInfo().userId;
          }

          ApiService.service('PUT', '/common/footer/b2b', {
            request: {
              aplt_emal: this.aplt_emal,
              aplt_nm: this.aplt_nm,
              aplt_tel: this.aplt_tel,
              //b2b_no: this.b2b_no,
              biz_nm: this.biz_nm,
              biz_no: this.biz_no,
              cnfm: this.cnfm,
              crte_id: this.crte_id,
              div: this.div,
              fld: this.fld,
              mgr_memo: this.mgr_memo,
              spec_cntn: this.spec_cntn,
              use_plc: this.use_plc,
            },
            serviceType: 'app',
          })
            .then(({ data }) => {
              console.log(data);
              if (data.isSucceed) {
                this.success = true;
                this.msg = `B2B 렌탈 서비스 신청이 완료되었습니다.<br>관리자 확인 후 연락 드리겠습니다.`;
                this.messagePop = true;
              } else {
                this.msg = data.error;
                this.messagePop = true;
              }
            })
            .catch(({ response }) => {
              console.log(response);
            })
            .finally(() => {
              this.refresh();
            });
        }
      });
    },
    close() {
      this.messagePop = false;
      //if (this.success) this.$router.push('/');
    },
  },
};
</script>
